import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="sobre" className="relative py-24 md:py-32 bg-cream overflow-hidden bg-grain" data-id="element-11">
      {/* Subtle background texture */}
      <div className="absolute inset-0 bg-papel-picado opacity-50 pointer-events-none" data-id="element-12" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-14">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="relative order-2 lg:order-1" data-id="element-15">
            {/* Decorative background block */}
            <div className="absolute -inset-4 md:-inset-6 bg-burgundy rounded-3xl transform rotate-3 opacity-10" data-id="element-16" />

            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-8 border-cream bg-cream" data-id="element-17">
              <img src="https://cdn.magicpatterns.com/uploads/cSDwDEAWcHuNBgyp3rN3gf/ChatGPT_Image_22_may_2026,_09_07_49_p.m..png" alt="Auténticos tacos mexicanos" className="w-full h-auto object-cover aspect-[4/5] md:aspect-square lg:aspect-[4/5]" loading="lazy" decoding="async" data-id="element-18" />
            </div>

            {/* Floating badge */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} className="absolute -bottom-6 -right-6 md:-bottom-10 md:-right-10 bg-orange text-white p-6 rounded-full shadow-xl w-32 h-32 md:w-40 md:h-40 flex items-center justify-center text-center transform -rotate-12" data-id="element-19">
              <span className="font-display font-bold text-lg md:text-xl leading-tight" data-id="element-20">
                Sabor
                <br data-id="element-21" />
                Auténtico
              </span>
            </motion.div>
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="order-1 lg:order-2 flex flex-col justify-center" data-id="element-22">
            <div className="flex items-center gap-4 mb-4" data-id="element-23">
              <div className="h-[1px] w-12 bg-orange" data-id="element-24" />
              <span className="text-orange font-bold tracking-[0.2em] uppercase text-sm" data-id="element-25">
                Nuestra Historia
              </span>
            </div>

            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-coral mb-8 leading-tight" data-id="element-26">
              SOBRE NOSOTROS
            </h2>

            <p className="text-charcoal/80 text-lg md:text-xl leading-relaxed mb-10 font-medium" data-id="element-27">
              At{' '}
              <strong className="text-coral font-bold" data-id="element-28">The Happy Taco</strong>,
              nuestra misión es ofrecer auténtica comida mexicana preparada con
              ingredientes frescos y sabor tradicional. Cada platillo está hecho
              con pasión, calidad y el verdadero sabor mexicano.
            </p>

            <div className="relative pl-8 border-l-4 border-orange py-2" data-id="element-29">
              <p className="font-script text-3xl md:text-4xl text-orange-light leading-snug" data-id="element-30">
                "Comer fresco, es vivir feliz."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}